/* ==========================================================================
   Pop Convert popup'ını tema diline uydurur.

   NEDEN BU DOSYA VAR
   Popup, Pop Convert uygulamasının kendi script'i tarafından #pop-convert-app
   içindeki bir shadow DOM'a basılıyor. Shadow DOM, theme.css'i içeri almaz —
   bu yüzden stil dışarıdan verilemiyor, shadow root'un içine enjekte etmek
   gerekiyor.

   KALICI ÇÖZÜM BURASI DEĞİL
   Renk, yazı ve metin asıl olarak Pop Convert'in kendi kampanya editöründen
   ayarlanır. Orası ayarlandığında bu dosya gereksiz kalır ve silinebilir:
     - layout/theme.liquid içindeki <script> satırını
     - ve bu dosyayı kaldırmak yeterli.

   KIRILGANLIK NOTU
   Seçiciler uygulamanın kendi sınıf adlarına dayanıyor (.modal-card,
   .submit-button). Uygulama arayüzünü değiştirirse bu kurallar sessizce
   etkisiz kalır — popup bozulmaz, sadece yeniden uygulamanın varsayılan
   görünümüne döner.
   ========================================================================== */
(function () {
  'use strict';

  var HOST_ID = 'pop-convert-app';
  var STYLE_ID = 'km-popup-brand';

  // Tema tokenlarını :root'tan okuyup shadow DOM'a taşıyoruz — orada
  // var(--color-accent) çözülür ama tokenlar :root'ta tanımlı olduğu için
  // aslında kalıtımla zaten geliyor. Yine de tema editöründen renk
  // değiştirildiğinde tutarlı kalsın diye doğrudan var() kullanıyoruz.
  var CSS = [
    /* Köşe yarıçapı tasarım dilinde her yerde 0. */
    '.modal-card, .modal-card * { border-radius: 0 !important; }',

    '.modal-card {',
    '  font-family: var(--font-body, sans-serif) !important;',
    '  border: 2px solid var(--color-text, #23303f) !important;',
    '}',

    '.modal-card h1, .modal-card h2, .modal-card h3 {',
    '  font-family: var(--font-heading, sans-serif) !important;',
    '  font-weight: 800 !important;',
    '  letter-spacing: -0.02em !important;',
    '  line-height: 1.05 !important;',
    '  color: var(--color-text, #23303f) !important;',
    '}',

    '.modal-card p { font-family: var(--font-body, sans-serif) !important; }',

    /* Ana buton: markanın turuncusu, düz köşe, sitedeki buton tipografisi. */
    '.modal-card .submit-button {',
    '  background: var(--color-accent, #ee7623) !important;',
    '  color: #fff !important;',
    '  font-family: var(--font-heading, sans-serif) !important;',
    '  font-weight: 700 !important;',
    '  letter-spacing: 0.04em !important;',
    '  border: 0 !important;',
    '}',

    '.modal-card input, .modal-card textarea, .modal-card select {',
    '  font-family: var(--font-body, sans-serif) !important;',
    '  border: 1px solid var(--color-divider, #cfd7df) !important;',
    '}',
  ].join('\n');

  function paint(host) {
    var root = host.shadowRoot;
    if (!root || root.getElementById(STYLE_ID)) return true;

    var style = document.createElement('style');
    style.id = STYLE_ID;
    style.textContent = CSS;
    root.appendChild(style);
    return true;
  }

  function tryPaint() {
    var host = document.getElementById(HOST_ID);
    return host && host.shadowRoot ? paint(host) : false;
  }

  function watch() {
    if (tryPaint()) return;

    // Uygulama script'i geç yüklenip host'u sonradan ekliyor. Popup görünene
    // kadar bekle, sonra gözlemciyi bırak — sürekli açık kalmasın.
    var observer = new MutationObserver(function () {
      if (tryPaint()) observer.disconnect();
    });

    observer.observe(document.body, { childList: true, subtree: true });

    // Popup hiç açılmayan sayfalarda gözlemci boşuna dinlemesin.
    setTimeout(function () {
      observer.disconnect();
    }, 20000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watch);
  } else {
    watch();
  }
})();
